import axios from 'axios';

const BASE_URL = ''; //API URL

// SCHEDULE SESSION API CALL
export const scheduleSession = async (sessionData) => {
    try {
        const res = await axios.post(`${BASE_URL}/schedule`, sessionData);
        return res.data;
    } catch (error) {
        throw error.response?.data || new Error('Something went wrong while scheduling the session');
    }
};
